const AppConfig = {
  auth: {
    LoggedIn: 'loggedInYeekee4DPlusFirebase'
  }
}

export default AppConfig;
